import { Link } from "react-router-dom";
import { siteInfo, categories } from "@/mocks/data";

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-100">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-play-circle-fill text-background-50 text-xl"></i>
                </div>
                <span className="text-xl font-bold text-background-50" style={{ fontFamily: "var(--font-heading)" }}>
                  {siteInfo.name}
                </span>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed mb-4">
                {siteInfo.description}
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="B站">
                  <i className="ri-bilibili-line"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">影视分类</h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快捷链接</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">首页</Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link>
                </li>
                <li>
                  <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">帮助中心</a>
                </li>
                <li>
                  <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">用户协议</a>
                </li>
                <li>
                  <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
              <ul className="space-y-2.5">
                <li className="flex items-start gap-2 text-sm text-foreground-400">
                  <i className="ri-mail-line mt-0.5 text-foreground-500"></i>
                  <span>{siteInfo.email}</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-foreground-400">
                  <i className="ri-phone-line mt-0.5 text-foreground-500"></i>
                  <span>{siteInfo.phone}</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-foreground-400">
                  <i className="ri-map-pin-line mt-0.5 text-foreground-500"></i>
                  <span>{siteInfo.address}</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800/60 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有 | 京ICP备2024XXXXXXXX号
            </p>
            <p className="text-xs text-foreground-500">
              本站内容来源于互联网，仅供学习交流使用
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}